import { clamp } from 'ramda';

import { IProgressBarProps } from '../types/public';

/**
 * Хук выполняет расчет длины закрашенной части (fill) прогрессбара
 * */
export const useFillWidth = (params: IProgressBarProps) => {
  const { currentStepCount, maxStepsCount } = params;

  try {
    if (!Number.isInteger(maxStepsCount) || maxStepsCount <= 0) {
      throw new Error('Входные данные некорректны');
    }

    const percent = Math.floor(clamp(0, 1, currentStepCount / maxStepsCount) * 100);

    return `${percent}%`;
  } catch (e) {
    return 0;
  }
};
